// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ce949969","239":"7b8ddb0f","455":"52604f8c","488":"3492d691"}[chunkId] + ".chunk.js";
};